


























































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ajax from '@/lib/ajax';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import { AppModule } from '@/store/modules/app';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';
import CreateJobWorkerOfferRequest from '@/models/JobWorkerOffers/CreateJobWorkerOfferRequest';

@Component({
    name: 'JobWorkerInterviewCreate'
})
export default class extends GiganautVueDialog {
 
    @Prop({required: true})
    jobWorker: JobWorkerDto;
    request: CreateJobWorkerOfferRequest = new CreateJobWorkerOfferRequest

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.request = new CreateJobWorkerOfferRequest();
            this.request.jobWorkerId = this.jobWorker.id;
        }
    }

    get disabled() {
		return this.jobWorker.status !== JobWorkerStatus.Offer 
    }

    get loading() {
        return JobDetailsModule.loadingDialog;
    }

   
    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        this.request.jobWorkerId = this.jobWorker.id;
        await JobDetailsModule.createJobWorkerOffer(this.request);
        this.dialog = false;
    }
}
